const itemDt            = require('./item-dt')
const itemFullcont      = require('./item-fullcont')
const itemFullcontLost  = require('./itemLost-fullcont')
const itemMenu          = require('./item-menu')
const itemPage          = require('./item-page')
const itemSnack         = require('./item-snack')
const itemQuickform     = require('./item-quickform')
const itemQuickview     = require('./item-quickview')
const itemChat          = require('./item-chat')
const itemReport        = require('./item-report')
const itemDialog        = require('./item-dialog')

export function start(detail){  
         
      obj[detail.elem].start(detail)

}/**/

const obj = {
   
      dt:               { start: (detail) =>{  itemDt.start(detail)                }},
      fullcont:         { start: (detail) =>{  itemFullcont.start(detail)          }},
      fullcontLost:     { start: (detail) =>{  itemFullcontLost.start(detail)      }},
      menu:             { start: (detail) =>{  itemMenu.start(detail)               }},
      page:             { start: (detail) =>{  itemPage.start(detail)               }},
      snack:            { start: (detail) =>{  itemSnack.start(detail)              }},
      quickform:        { start: (detail) =>{  itemQuickform.start(detail)           }},
      quickview:        { start: (detail) =>{  itemQuickview.start(detail)           }},
      chat:             { start: (detail) =>{  itemChat.start(detail)                }},
      report:           { start: (detail) =>{  itemReport.start(detail)              }},
      dialog:           { start: (detail) =>{  itemDialog.start(detail)              }},
}